up.migrate.renamedPackage('layout', 'viewport');
up.viewport.config.patch(function (config) {
    up.migrate.renamedProperty(config, 'viewports', 'viewportSelectors');
    up.migrate.renamedProperty(config, 'fixedTop', 'fixedTopSelectors');
    up.migrate.renamedProperty(config, 'fixedBottom', 'fixedBottomSelectors');
    up.migrate.renamedProperty(config, 'anchoredRight', 'anchoredRightSelectors');
    up.migrate.renamedProperty(config, 'snap', 'revealSnap');
    up.migrate.removedProperty(config, 'scrollSpeed');
});
up.viewport.closest = function (...args) {
    up.migrate.deprecated('up.viewport.closest()', 'up.viewport.get()');
    return up.viewport.get(...args);
};
up.viewport.scroll = function (viewport, top, options = {}) {
    up.migrate.deprecated('up.scroll()', 'Element#scrollTo()');
    viewport = up.fragment.get(viewport, options);
    viewport.scrollTo(Object.assign(Object.assign({}, options), { top }));
    return up.migrate.formerlyAsync('up.scroll()');
};
up.scroll = up.viewport.scroll;
